export const boldList = [
    {
      id: "0",
      text: "Transport company’s duties and responsibilities:",
      features: [
        {
          id: "0",
          text: "ASB shall provide the school transportation, whereby the student shall be picked up from the assigned pick up point, dropped at the school and dropped back to the assigned drop off point, as agreed and accepted by the parent on the transport form. ASB may change the route/pickup/drop off points and timing to reorganize or for efficient services and notify the parents in advance.",
        },
        {
          id: "1",
          text: "GPS, RFID & CCTV tracking-monitoring security system is installed in all the ASB buses. The GPS tracking system and RFID device is in synchronous with the RFID card assigned to the students. This monitors the bus usage of the students. ",
        },
        {
          id: "2",
          text: "ASB shall provide a suitable replacement for breakdown buses.",
        },
        {
          id: "3",
          text: "The trips schedule shall be observed as per the school timing.",
        },
        {
          id: "4",
          text: "Working days will be observed as stipulated by MoE / KHDA / SPEA directives for all private schools.",
        },
        {
          id: "5",
          text: "Bus drivers will be equipped with a communicating device and shall be strictly instructed not to use it while driving. Parents shall not contact drivers on their mobiles, unless during emergencies, so that the drivers are not distracted.",
        },
        {
          id: "6",
          text: "Drivers shall be decently dressed, with good conduct and knowledge of location assigned. All the drivers have to go thorough periodic training sessions related to the safety of the students.",
        },
      ],
    },
  
    {
      id: "1",
      text: "Parent’s duties and responsibilities",
      features: [
        {
          id: "0",
          text: "The student riding the school bus must behave in a satisfactory manner in order for the driver to remain alert to the driving hazards, ensuring the safety of the passengers in the bus.",
        },
        {
          id: "1",
          text: "It is the duty of the parents to be present at the pick-up and drop off points before 5 minutes of the bus scheduled arrival time to take the custody of the students. ASB will not be responsible in any manner, once the students are dropped off at the pickup / drop-off point. In the mornings If there is a delay from parent side, parent has to drop their children to the school, without holding the driver accountable. ",
        },
        {
          id: "2",
          text: "In case of a student escort is not present at the drop off point, the drivers are instructed to bring back the student to the school of below grade 3. The parents will be informed accordingly, to take back their ward from the school.",
        },
        {
          id: "3",
          text: "The student shall be strictly allowed to travel only on the bus route assigned to him/her. However, during emergency the usage of another bus route may be allowed upon the prior written approval from the school and ASB Transport officer.",
        },
        {
          id: "4",
          text: "In case of a change of a route, due to change in the residence or as requested by the parent, the parent should immediately inform ASB and get the RFID cards replaced, failing which, the student will not be allowed to use the bus for the new route. The ASB has the right to cancel the contract if the new address is outside the scope of the school transport service.",
        },
        {
          id: "5",
          text: "The damages in the bus, if found to occur due to the mishandling or willful damage by the student, the cost of which will be recovered from the parent.",
        },
      ],
    },
  
    {
      id: "2",
      text: "Transport fees:",
      features: [
        {
          id: "0",
          text: "Parents agree to pay the transport fees as per the following table, before the due dates mentioned, therein:",
          table1: "true",
        },
        {
          id: "1",
          text: "The transport fees for each year shall be notified ahead of the start of the academic year at ASB website (www.alsaraya.ae) Parents are advised to go through and check the same.Once the student starts using the bus in the beginning of Term – 1, it shall be deemed that the parent has accepted the fee for the academic year as notified in",
          url: "www.alsaraya.ae.",
        },
        {
          id: "2",
          text: "In case of fee default, after 5 reminders vide SMS/ E mail / Telephone calls the student will not be permitted to board the bus and ASB, will be compelled to de-activate RFID card of the student. Once this card is deactivated we won’t be able to track the student. In such cases parents will be solely responsible for the safety of the student and ASB shall not be held responsible in any manner what so ever.",
        },
        {
          id: "3",
          text: "No student is allowed to travel in the bus without payment of transport fees. If student has used bus service during anytime of the school term, full term transport student has used bus service during anytime of the school term, full term transport.",
        },
        {
          id: "4",
          text: "ASB may not pickup defaulting student from residence pick up point to school and/or may not drop from school to residence drop off point. Even if a defaulting student uses the ASB bus for arrival to school, the student shall not be transported back from school to residence drop off pick up point. In such case, it will be the responsibility of the parent to take care of their ward’s transportation.",
        },
        {
          id: "5",
          text: "The transport fee may be remitted through Cash or Cheque at ASB cash counter at the school or on line transfers through ADCB & ENBD banks. (Refer www.ASB.ae for details) Cash/cheques should not be deposited at bank’s teller counters, which shall attract bank charges to the account of the parent, which parent agrees to pay.",
        },
        {
          id: "6",
          text: "Dishonored cheques will attract a charge of Dhs. 200, without prejudice to our rights of legal recourse.",
        },
        {
          id: "7",
          text: "Parents should avoid sending cash or cheque with student or the driver / attendant of the bus. ASB shall not be responsible for any mishandling/misplacement of cash or cheque in such cases.",
        },
        {
          id: "8",
          text: "Once the RFID card has been issued and the bus/seat allocation has been done, the fee is payable, irrespective of the usage or non-usage of the bus service.",
        },
        {
          id: "9",
          text: "Own transport students are not allowed to use the bus. However, if ASB finds out that the own transport student is travelling in the bus, the student will be immediately disallowed and the transport fees shall be recovered from the parent as per ASB fee charge policy.",
          table2: "true",
          point: "true",
          points: [
            {
              index: "0",
              text: "Change in pickup or drop-off point at the beginning of the term or at any time during the academic year will attract administration charges of Dhs. 100. However, this change will be subject to the seat availability and if the new change is within our logistics route plan.",
            },
            {
              index: "1",
              text: "For the purpose of bus usage, period means calendar period means, which includes holidays and weekends.",
            },
          ],
        },
        {
          id: "10",
          text: "It is mandatory for the students to give a 3 (three) months’ notice (with payment of fee) to ASB Transport desk, if they wish to discontinue the usage of school transport at any time during the academic year (April - March). If the bus usages are discontinued without written notice, then it will be deemed that the student continues to use the bus services, irrespective of actual usage. This also applies to the fee defaulter of that particular term.",
          title: "Transport Cancellation Policy :",
          red: "true",
        },
        {
          id: "11",
          point: "true",
          points: [
            {
              index: "0",
              text: "Sibling discount for the 4th child – 25% of the transport fees.",
            },
            {
              index: "1",
              text: "Parents of the fourth Child must contact Transport Desk of ASB at School, to apply for discount, along with the duly filled application form. (Click here for the sibling discount form) The discount (if any, as approved) shall be applicable only if parent pay full years fee for all siblings before due date of Term 1 as under: ",
            },
          ],
          title: "Sibling Discount will be as under:",
        },
      ],
    },
  ];